import { Box, Chip, Stack } from "@mui/material";

import { ChatMessageWithParts } from "src/views/assistant/types";
import DialogueActions from "src/views/assistant/components/header/DialogueActions";
import { useProposalGenerationStore } from "../store/ProposalGenerationStore";
import {
  getReportTypeDisplayName,
  stageDisplayConfig,
} from "../services/ProposalGenerationServices";
import { useGetStageConfig } from "../services/ProposalGenerationConfigService";
import { StageConfigButton } from "./StageConfigButton";

type ProposalGenerationHeaderProps = {
  dialogueId: number | null;
  onNewChat: () => void;
  dialogue: ChatMessageWithParts[];
};

const ProposalGenerationHeader = ({
  dialogueId,
  onNewChat,
  dialogue,
}: ProposalGenerationHeaderProps) => {
  const {
    sequenceNumber,
    reportType,
    stages,
    stageReportPrefix,
    stageReportSuffixLabel,
  } = useProposalGenerationStore();
  const { data: stageConfig } = useGetStageConfig();

  const reportTypeDisplayName = getReportTypeDisplayName(
    reportType || undefined,
    sequenceNumber || undefined,
    stageDisplayConfig(
      stageReportPrefix,
      stageReportSuffixLabel,
      stageConfig?.effective,
    ),
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      gap={{ xs: 2, sm: 4, md: 6, xl: 8 }}
      sx={{
        px: 2,
        width: "100%",
        position: "relative",
      }}
    >
      <Box sx={{ minWidth: 0, overflow: "hidden" }}>
        <span style={{ fontWeight: 600, fontSize: "1.1rem" }}>
          Proposal Generation
        </span>
      </Box>

      {sequenceNumber != null && (
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            pointerEvents: "none",
            maxWidth: "50%",
          }}
        >
          <Chip
            label={`Stage ${sequenceNumber}${stages.length > 1 ? ` of ${stages.length}` : ""}: ${reportTypeDisplayName}`}
            size="medium"
            color="primary"
            variant="outlined"
            sx={{
              fontSize: "0.875rem",
              fontWeight: 500,
              maxWidth: "100%",
              "& .MuiChip-label": {
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              },
            }}
          />
        </Box>
      )}

      <Box
        sx={{ flexShrink: 0, display: "flex", alignItems: "center", gap: 2 }}
      >
        <StageConfigButton />
        <DialogueActions
          dialogueId={dialogueId}
          onNewChat={onNewChat}
          dialogue={dialogue}
        />
      </Box>
    </Stack>
  );
};

export default ProposalGenerationHeader;
